export enum ComponentId {
  NAME = "name",
  REGON = "regon",
  PHONE = "phone",
  EMAIL = "email",
  STREET = "street",
  STREET_2 = "street2",
  ZIP_CODE_PL = "zipCodePL",
  ZIP_CODE_GENERIC = "zipCodeGeneric",
  CITY = "city",
  COUNTRY = "country",
  PROVINCE = "province",
}
